<template>
    <div>
        <div class="field has-addons">
            <div class="control tooltip has-cursor-pointer" @click="$emit('with-time-toggle', !withTime)" data-tooltip="Click to toggle between date and datetime">
                <div class="button is-static">
                    <i class="fa cal-icon" :class="{ 'fa-calendar' : !withTime, 'fa-clock-o' : withTime }"></i>
                </div>
            </div>
            <div class="control" @click="openCalendar">
                <div class="input flex-con is-grow xs-pad-lr">
                    <div>
                        <timestamp
                            v-if="value"
                            :value="value"
                            :is-full="!withTime ? false : true"
                            time-format="h:mm A"
                        ></timestamp>
                        <span v-else class="no-selection">
                            {{label}}
                        </span>
                    </div>
                    <div v-if="value" @click="clear($event)">
                        <a class="fa fa-times-circle-o"></a>
                    </div>
                </div>
            </div>
        </div>
        <datetime
            class="datetime-is-hidden"
            ref="date"
            v-model="localValue"
            :type="!withTime ? 'date' : 'datetime'"
        ></datetime>
    </div>
</template>

<script>
export default {
    name : "SearchDatePicker",
    props : {
        value : {
            required : false,
        },
        label : {
            type : String,
            required : true,
        },
        withTime : {
            type : Boolean,
            default : false,
        },
    },
    computed : {
        localValue : {
            get () { return this.value },
            set(localValue) {
                //the datetime component likes to set empty strings instead of null
                //so make sure we aren't emitting a change when a initial null value is passed that is then
                //immediately changed to an empty string by the date time component
                //this is important if network requests are made based on there being a changed value in the input
                if((!localValue && !this.value) || localValue === this.value){
                    return;
                }
                this.$emit('input', localValue);
            },
        }
    },
    methods : {
        openCalendar () {
            this.$refs.date.$el.children[0].click();
        },
        clear ($event) {
            $event.stopPropagation();
            this.localValue = null;
        },
    },
}
</script>

<style scoped>
    .field {
        margin-bottom:0 !important;
    }
    .input {
        cursor:pointer;
        padding:0 8px;
    }
    .cal-icon {
        transform:translate(0, -1px)
    }
</style>
